import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import cl from 'classnames';
import { HEADSETS } from 'src/constants';
import { usePage } from 'src/hooks';
import { useAppDispatch } from 'src/store';
import { useHeadsetById, fetchHeadsetMetaAction } from 'src/services/headsets';
import { PageSwitcher } from 'src/components';
import styles from './headsetLogsStyle.module.scss';

export const HeadsetLogs = () => {
  const { hotel: companyId, headset: headsetId } = useParams() as {
    hotel: string;
    headset: string;
  };
  const {
    access: { accessMap },
  } = usePage();
  const dispatch = useAppDispatch();
  const headset = useHeadsetById(headsetId);
  const [isLoading, setIsLoading] = useState<null | boolean>(null);

  const headsetIsLoaded = useMemo(() => Boolean(headset), [headset]);
  const meta = useMemo(() => headset?.meta || { log: '' }, [headset?.meta]);

  useEffect(() => {
    if (!headsetIsLoaded) {
      return;
    }

    setIsLoading(true);

    dispatch(fetchHeadsetMetaAction({ companyId, headsetId })).then(() => {
      setIsLoading(false);
    });
  }, [dispatch, headsetIsLoaded, headsetId, companyId]);

  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <div
          className={cl(
            styles.pageSwitcherContainer,
            accessMap[HEADSETS].length === 1 && styles.inactive,
          )}
        >
          <PageSwitcher
            className={styles.pageSwitcher}
            selectClassName={styles.mobileSelect}
          />
        </div>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.wrapper}>
          <div className={styles.logs}>{meta.log}</div>
          {isLoading !== false && (
            <div className={styles.loading}>
              <div className={styles.loader} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeadsetLogs;
